import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M17 11V2H7a2 2 0 00-2 2v24a2 2 0 002 2h18a2 2 0 002-2V12h-9a1 1 0 01-1-1zm-7 4h6a1 1 0 010 2h-6a1 1 0 010-2zm12 10H10a1 1 0 010-2h12a1 1 0 010 2zm1-5a1 1 0 01-1 1H10a1 1 0 010-2h12a1 1 0 011 1z"/><path d="M26.8 10a3.4 3.4 0 00-.8-1.4l-.3-.3-5-5-.3-.3a3.4 3.4 0 00-1.4-.8V10z"/>';
export var FileSVG = function FileSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FileSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FileSVG);